import React, { useEffect } from "react";
import { loadingsShow } from "../../Services/PostAPI";
import customerMarkupData from "./tableData.json";

import {
  initializeCustomerMarkupScreen,
  editCustomerMarkup,
  addCustomerMarkup,
  fetchCustomerMarkup,
  fetchFuelCompanyProviderDD,
  fetchFuelCustomerCompanyNameProviderDD,
} from "../../Redux/Actions/customersMarkup";
import { connect } from "react-redux";
import CustomerMarkupComponent from "../../components/CustomerMarkup";

const CustomerMarkupScreen = (props) => {
  const {
    fetchCustomerMarkup,
    fuelCompanyProviderDD,
    fetchFuelCompanyProviderDD,
    fuelCustomerCompanynNameProviderDD,
    fetchFuelCustomerCompanyNameProviderDD,
    editCustomerMarkup,
    addCustomerMarkup,
    initializeCustomerMarkupScreen,
    showPageLevelLoader,
    customerMarkupListView,
    paginationInfo,
    isLoading,
    isEditCustomerMarkupSuccess,
    isEditCustomerMarkupError,
    isCreateCustomerMarkupSuccess,
    isCreateCustomerMarkupError,
    screenPermissions
  } = props;

  useEffect(() => {
    initializeCustomerMarkupScreen();
    fetchCustomerMarkup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customerMarkupProps = {
    fetchCustomerMarkup,
    fuelCompanyProviderDD,
    fetchFuelCompanyProviderDD,
    fuelCustomerCompanynNameProviderDD,
    fetchFuelCustomerCompanyNameProviderDD,
    editCustomerMarkups: editCustomerMarkup,
    addCustomerMarkup,
    isEditCustomerMarkupSuccess,
    isEditCustomerMarkupError,
    isCreateCustomerMarkupSuccess,
    isCreateCustomerMarkupError,
    ...customerMarkupData,
    tableData: {
      ...customerMarkupData.tableData,
      rows: customerMarkupListView,
    },
    paginationInfo: {
      ...customerMarkupData.paginationInfo,
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    screenPermissions
  };

  if (showPageLevelLoader) {
    loadingsShow("block");
    return null;
  }
  loadingsShow("none");

  return (
    <div>
      <CustomerMarkupComponent {...customerMarkupProps} />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    initializeCustomerMarkupScreen: () =>
      dispatch(initializeCustomerMarkupScreen()),
    fetchCustomerMarkup: (payload) => dispatch(fetchCustomerMarkup(payload)),
    fetchFuelCompanyProviderDD: (payload) =>
      dispatch(fetchFuelCompanyProviderDD(payload)),
    fetchFuelCustomerCompanyNameProviderDD: (payload) =>
      dispatch(fetchFuelCustomerCompanyNameProviderDD(payload)),
    editCustomerMarkup: (payload) => dispatch(editCustomerMarkup(payload)),
    addCustomerMarkup: (payload) => dispatch(addCustomerMarkup(payload)),
  };
};

const selectIsLoading = (companyReducer) => companyReducer.isLoading;
const selectPaginationCustomerMarkupInfo = (customerMarkupReducer) =>
  customerMarkupReducer.paginationInfo;
const selectIsLoadingPage = (companyReducer) => companyReducer.isLoadingPage;
const selectIsPageLevelError = (companyReducer) =>
  companyReducer.isPageLevelError;

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    showPageLevelLoader: selectIsLoadingPage(state.customerMarkupReducer),
    paginationInfo: selectPaginationCustomerMarkupInfo(
      state.customerMarkupReducer
    ),
    isPageLevelError: selectIsPageLevelError(state.customerMarkupReducer),
    isFetchingGridData: selectIsLoading(state.customerMarkupReducer),
    customerMarkupListView: selectCustomerMarkupList(
      state.customerMarkupReducer
    ),
    fuelCompanyProviderDD: selectFuelCompanyProviderDD(
      state.customerMarkupReducer
    ),
    fuelCustomerCompanynNameProviderDD: selectFuelCustomerCompanynNameProviderDD(
      state.customerMarkupReducer
    ),
    isEditCustomerMarkupSuccess: selectisEditCustomerMarkupSuccess(
      state.customerMarkupReducer
    ),
    isEditCustomerMarkupCardError: selectisEditCustomerMarkupCardError(
      state.customerMarkupReducer
    ),
    isCreateCustomerMarkupSuccess: selectIsCreateCustomerMarkupSuccess(state),
    isCreateCustomerMarkupError: selectIsCreateCustomerMarkupError(state),
  };
};

const selectIsCreateCustomerMarkupSuccess = (state) =>
  state.customerMarkupReducer.isCreateCustomerMarkupSuccess;

const selectIsCreateCustomerMarkupError = (state) =>
  state.customerMarkupReducer.isCreateCustomerMarkupError;
const selectisEditCustomerMarkupSuccess = (customerMarkupReducer) =>
  customerMarkupReducer.isEditCustomerMarkupSuccess;
const selectisEditCustomerMarkupCardError = (customerMarkupReducer) =>
  customerMarkupReducer.isEditCustomerMarkupCardError;

const selectCustomerMarkupList = (customerMarkupReducer) =>
  customerMarkupReducer.customerMarkupListView;
const selectFuelCompanyProviderDD = (customerMarkupReducer) =>
  customerMarkupReducer.fuelCompanyProviderDD;
const selectFuelCustomerCompanynNameProviderDD = (customerMarkupReducer) =>
  customerMarkupReducer.fuelCustomerCompanynNameProviderDD;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerMarkupScreen);
